import { useState, useEffect } from 'react';
import { getRequestCount, subscribeToRequests } from '../api/requestCounter';

/** Returns true whenever any API request is in-flight. */
export function useIsLoading(): boolean {
    const [loading, setLoading] = useState(() => getRequestCount() > 0);

    useEffect(() => {
        return subscribeToRequests(() => {
            setLoading(getRequestCount() > 0);
        });
    }, []);

    return loading;
}
